import { Flex } from "@chakra-ui/react";
import SelectableButton from "components/Button/SelectableButton";
import colors from "core/resources/theme/colors";
import { MovimentacaoBancariaRequestParams } from "features/movimentacoes-bancarias/typings";
import { OperacaoEnum } from "../../../../../../../../../core/resources/enums/conta";

interface TagStatusFiltroMovimentacoesProps {
  onChangeFiltro: (
    newValues: Partial<MovimentacaoBancariaRequestParams>
  ) => void;
  filtro: MovimentacaoBancariaRequestParams;
}

export default function TagStatusFiltroMovimentacoes({
  filtro,
  onChangeFiltro,
}: TagStatusFiltroMovimentacoesProps) {
  const onUnselectConciliado = () => onChangeFiltro({ conciliado: undefined });

  const onUnselectNaoConciliado = () =>
    onChangeFiltro({ naoConciliado: undefined });

  const onUnselectOperacao = () =>
    onChangeFiltro({
      operacao: undefined,
    });

  return (
    <Flex gridGap="8px" flexWrap="wrap" justifyContent="center">
      <SelectableButton
        selected={filtro.operacao === OperacaoEnum.Receita}
        onClick={() => {
          onChangeFiltro({
            operacao: OperacaoEnum.Receita,
          });
        }}
        onUnselect={onUnselectNaoConciliado}
        rounded="full"
        selectedColor={colors.green500}
        fontSize="14px"
      >
        Receitas
      </SelectableButton>

      <SelectableButton
        selected={filtro.operacao === OperacaoEnum.Despesa}
        onClick={() => {
          onChangeFiltro({
            operacao: OperacaoEnum.Despesa,
          });
        }}
        onUnselect={onUnselectOperacao}
        rounded="full"
        selectedColor={colors.red500}
        fontSize="14px"
      >
        Despesas
      </SelectableButton>

      <SelectableButton
        selected={filtro.conciliado === true}
        onClick={() => {
          onChangeFiltro({
            conciliado: true,
          });
          onUnselectNaoConciliado();
        }}
        onUnselect={onUnselectConciliado}
        rounded="full"
        selectedColor={colors.green500}
        fontSize="14px"
      >
        Conciliado
      </SelectableButton>

      <SelectableButton
        selected={filtro.naoConciliado === true}
        onClick={() => {
          onChangeFiltro({
            naoConciliado: true,
          });
          onUnselectConciliado();
        }}
        onUnselect={onUnselectNaoConciliado}
        rounded="full"
        selectedColor={colors.yellow}
        fontSize="14px"
      >
        Não conciliado
      </SelectableButton>
    </Flex>
  );
}
